import type { Schema } from '@biteinc/common';
import { OrderChannel } from '@biteinc/enums';

export const createLocationGuidedSchema: Schema.Model = {
  displayName: 'location',
  type: 'object',
  fields: {
    orderChannel: {
      displayName: 'Order Channel',
      type: 'stringEnum',
      enum: OrderChannel,
      required: true,
      ui: 'radiolist',
      defaultValue: OrderChannel.Kiosk,
    },
    channelName: {
      type: 'shortString',
      displayName: 'Channel Name',
      required: true,
      tooltip: {
        text: 'Most of the time this should be the same as the Order Channel, but it can be different if you have multiple locations with the same Order Channel and need a way to differentiate them.',
      },
    },
    menuReferenceLocationId: {
      displayName: 'Menu Reference Location',
      type: 'mongoId',
      required: true,
      biteOnly: true,
      ui: 'dropdown',
    },
    orgAppearanceId: {
      type: 'mongoId',
      displayName: 'Org Appearance',
      required: true,
      ui: 'dropdown',
    },
    phoneNumber: {
      type: 'phone',
      displayName: 'Phone Number',
    },
    fullAddress: {
      type: 'object',
      subtype: 'Address',
      displayName: 'Full Civic Address',
    },
  },
};
